export default __webpack_public_path__ + "static/media/General's Legguards of the Watchtowers.6c33a3ef.jpg";